import React from 'react';
//  { useMemo }
import { useLanguage } from '../../locale/useLanguage';
import {
  // PremiseType,
  WeekDay,
} from '../../models';
import { HourOption, HourSelector } from '../HourSelector/HourSelector';
// import {
//   RadioButtonGroup,
//   RadioButtonGroupOption,
// } from '../RadioButtonGroup/RadioButtonGroup';
import { WeekDayPicker } from '../WeekDayPicker/WeekDayPicker';

import './ConciergeForm.css';

const morningHourOptions: HourOption[] = [
  { value: '08', label: '08' },
  { value: '09', label: '09' },
  { value: '10', label: '10' },
  { value: '11', label: '11' },
  { value: '12', label: '12' },
  { value: '13', label: '13' },
];

const afternoonHourOptions: HourOption[] = [
  { value: '14', label: '14' },
  { value: '15', label: '15' },
  { value: '16', label: '16' },
  { value: '17', label: '17' },
  { value: '18', label: '18' },
  { value: '19', label: '19' },
  { value: '20', label: '20' },
  { value: '21', label: '21' },
  { value: '22', label: '22' },
  { value: '23', label: '23' },
];

type ConciergeFormProps = {
  // premiseTypeFieldValue?: PremiseType;
  // onPremiseTypeChange: (val: PremiseType) => void;
  selectedWeekDays?: WeekDay[];
  onWeekDaysChange?: (weekDay: WeekDay) => void;
  daysFieldError?: string;
  conciergeMorningFromHour: string;
  conciergeMorningToHour: string;
  conciergeAfternoonFromHour: string;
  conciergeAfternoonToHour: string;
  conciergeMorningFromHourChange: (option: string | undefined) => void;
  conciergeMorningToHourChange: (option: string | undefined) => void;
  conciergeAfternoonFromHourChange: (option: string | undefined) => void;
  conciergeAfternoonToHourChange: (option: string | undefined) => void;
  conciergeOpeningHoursError?: string;
};

export const ConciergeForm: React.FC<ConciergeFormProps> = ({
  // premiseTypeFieldValue,
  // onPremiseTypeChange,
  selectedWeekDays,
  onWeekDaysChange,
  daysFieldError,
  conciergeMorningFromHour,
  conciergeMorningToHour,
  conciergeAfternoonFromHour,
  conciergeAfternoonToHour,
  conciergeMorningFromHourChange,
  conciergeMorningToHourChange,
  conciergeAfternoonFromHourChange,
  conciergeAfternoonToHourChange,
  conciergeOpeningHoursError,
}) => {
  const [t] = useLanguage();

  // const premiseTypeOptions: RadioButtonGroupOption<PremiseType>[] = useMemo(
  //   () => [
  //     {
  //       label: t('addressNotesView.reception'),
  //       value: PremiseType.Reception,
  //     },
  //     {
  //       label: t('addressNotesView.office'),
  //       value: PremiseType.Office,
  //     },
  //     {
  //       label: t('addressNotesView.store'),
  //       value: PremiseType.Store,
  //     },
  //   ],
  //   [t]
  // );

  return (
    <>
      {/* <div className="concierge-form--field-container">
        <label className="concierge-form--label-style concierge-form--label-container">
          {t('addressNotesView.addressType')}
        </label>
        <RadioButtonGroup
          options={premiseTypeOptions}
          selectedValue={premiseTypeFieldValue}
          onChangeValue={onPremiseTypeChange}
        />
      </div> */}
      <div className="concierge-form--days-container">
        <p className="concierge-form--label-style">
          {t('addressNotesView.selectDays')}
        </p>
        <WeekDayPicker
          onDayClicked={onWeekDaysChange}
          selectedDays={selectedWeekDays}
        />
        {daysFieldError && <p className="error-message">{daysFieldError}</p>}
      </div>
      <div className="concierge-form--hour-container">
        <div className="concierge-form--time-slot-line">
          <div className="concierge-form--morning-col concierge-form--col-title">
            <div className="concierge-form--col-description concierge-form--time-description-container concierge-form--label-style">
              {t('addressNotesView.selectHours')}
            </div>
            <div className="concierge-form--time-slot-container">
              <p className="subtitle concierge-form--time-slot">
                {t('addressNotesView.morning')}
              </p>
            </div>
          </div>
          <div className="concierge-form--morning-col">
            <div className="concierge-form--time-description-container concierge-form--label-style">
              {t('addressNotesView.fromTime')}
            </div>
            <HourSelector
              onChange={conciergeMorningFromHourChange}
              value={conciergeMorningFromHour}
              options={morningHourOptions}
            />
          </div>
          <div className="concierge-form--morning-col">
            <div className="concierge-form--time-description-container concierge-form--label-style">
              {t('addressNotesView.toTime')}
            </div>
            <HourSelector
              onChange={conciergeMorningToHourChange}
              value={conciergeMorningToHour}
              options={morningHourOptions}
            />
          </div>
        </div>
        <div className="concierge-form--time-slot-line">
          <div className="concierge-form--col-title">
            <p className="subtitle concierge-form--time-slot">
              {t('addressNotesView.afternoon')}
            </p>
          </div>
          <div className="concierge-form--slot-col-container">
            <HourSelector
              options={afternoonHourOptions}
              onChange={conciergeAfternoonFromHourChange}
              value={conciergeAfternoonFromHour}
            />
          </div>
          <div className="concierge-form--slot-col-container">
            <HourSelector
              options={afternoonHourOptions}
              onChange={conciergeAfternoonToHourChange}
              value={conciergeAfternoonToHour}
            />
          </div>
        </div>
        {conciergeOpeningHoursError && (
          <p className="error-message">{conciergeOpeningHoursError}</p>
        )}
      </div>
    </>
  );
};
